import {
  GET_SETTINGS_FAILED,
  GET_SETTINGS_REQUEST,
  GET_SETTINGS_SUCCESS,
  SET_SETTINGS_REQUEST,
  SET_SETTINGS_SUCCESS,
  SET_SETTINGS_FAILED,
  GET_SETTINGS_USERS_REQUEST,
  GET_SETTINGS_USERS_SUCCESS,
  GET_SETTINGS_USERS_FAILED,
  GET_SIGNATURE_ALERTS_FAILED,
  UPDATE_SIGNATURE_ALERT_FAILED,
  GET_SIGNATURE_ALERTS_REQUEST,
  GET_SIGNATURE_ALERTS_SUCCESS,
  UPDATE_SIGNATURE_ALERT_SUCCESS,
} from './actionTypes';

const initialAlert = { signatures_count: undefined, send_letter: false, email: '', subject: '', body: '' };

const initialState = {
  loading: false,
  isLoadingAlerts: false,
  error: '',
  users: null,
  settings: {},
  alerts: new Array(3).fill(initialAlert),
};

// we should render min 3 alerts even if API returned less then 3
const normalizeAlerts = (alerts) => {
  if (alerts.length > 2) return alerts;
  const newAlerts = [...alerts];
  newAlerts.length = 3;
  newAlerts.fill(initialAlert, alerts.length, 3);

  return newAlerts;
};

const applyUpdatedAlertToState = (alerts, { alert, id, index }) => {
  const newAlerts = [...alerts];
  let i = id ? alerts.findIndex(({ id }) => id === alert.id) : index;
  // if we can't find the updated alert in the store, then this is a newly created alert which should replace any item without id
  newAlerts[i] = alert;
  return newAlerts;
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SETTINGS_USERS_REQUEST:
    case GET_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SETTINGS_USERS_FAILED:
    case GET_SETTINGS_FAILED:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.settings,
        loading: false,
      };
    case SET_SETTINGS_REQUEST:
      return {
        ...state,
        settings: { ...state.settings, ...action.settings },
      };
    case SET_SETTINGS_SUCCESS:
      return {
        ...state,
      };
    case SET_SETTINGS_FAILED:
      return {
        ...state,
        error: action.error,
        settings: { ...state.settings, ...action.settings },
      };
    case GET_SETTINGS_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
        loading: false,
      };

      case GET_SIGNATURE_ALERTS_REQUEST:
        return {
          ...state,
          isLoadingAlerts: true,
        };
      case GET_SIGNATURE_ALERTS_SUCCESS:
        return {
          ...state,
          alerts: normalizeAlerts(action.alerts),
          isLoadingAlerts: false,
        };
        case GET_SIGNATURE_ALERTS_FAILED:
        case UPDATE_SIGNATURE_ALERT_FAILED:
          return {
            ...state,
            error: action.error,
            isLoadingAlerts: false,
          };
      case UPDATE_SIGNATURE_ALERT_SUCCESS:
        return {
          ...state,
          alerts: applyUpdatedAlertToState(state.alerts, action.data),
        };
    default:
      return state;
  }
};
export default reducer;
